<div class="provider"
*ngIf="provider"
(click)="!isProviderDemo() ? providerDetail(provider) : null"
[ngClass] = "{'demo': isProviderDemo()}">
    <!-- Columna de la imagen -->
    <div class="image-container">
      <img [src]="provider?.img" [alt]="provider.name" (error)="onImageError($event)" />
    </div>
  
    <!-- Columna de información -->
    <div class="info-container">
      <div class="contTitle" [ngClass] = "{'demo-title': isProviderDemo()}">
        <p class="name">
          {{ provider.name ? provider.name : 'N' }}
        </p>
      </div>
    </div>
</div>